import React from "react";
import Douglas from "../../assets/Douglas.jpg";
import { Container, Image, Text } from "./styles";

const Banner = () => {
    return(
        <Container>
            <Text>
                <h2>Sobre mim</h2>
                <p>Meu nome é Douglas José Fogaça, tenho 36 anos e nasci em Paranatinga. Minha trajetória no mercado imobiliário começou de forma inusitada: após sofrer um golpe, busquei conhecimento para entender como recuperar meu dinheiro. Nesse processo, descobri uma verdadeira paixão pelo setor e transformei aquela experiência difícil em motivação para ajudar outras pessoas a não passarem pelo mesmo erro.</p>
                <p>Ao longo da minha carreira, já somei R$ 116 milhões em VGV e tive a honra de atender 138 famílias, sempre com o propósito de orientá-las a fazer bons negócios com segurança, transparência e tranquilidade.</p>
                <p>Minha maior satisfação é ver famílias realizando sonhos através da compra ou venda de um imóvel. Esse compromisso é o que me move todos os dias, aliado à minha maior motivação: minha família, que é abençoada e busca abençoar outras famílias.</p>
                <p>Fora do trabalho, sou apaixonado por esportes, que me ajudam a manter o equilíbrio e a disciplina que também levo para minha profissão.</p>
                <p>Seja para comprar, vender ou investir, conte comigo para transformar seus objetivos em conquistas reais.</p>
            </Text>

            <Image>
                <img src={Douglas} alt=""/>
            </Image>
        </Container>
    )
}

export default Banner;